import React, { useState, useEffect } from "react";
import Select from "react-select";
import { AvField } from "availity-reactstrap-validation";

const CustomSelect = (props) => {
  const [selectedtValue, setSelectedValue] = useState();
  const {
    options,
    name,
    errorMessage,
    defaultValue,
    value, // controlled value (option object or primitive)
    validate,
    optionLabel = "label",
    optionValue = "value",
    onChange = null,
    onInputChange = null,
    isClearable,
    isSearchable = true,
    isDisabled,
    isLoading = false,
    isRtl,
    isMulti,
    placeholder = "Select...",
    isAvForm = true,
    isOptionDisabled = null,
  } = props;

  // when defaultValue (primitive) or options change, try to resolve to an option
  useEffect(() => {
    if (options?.length && defaultValue != undefined) {
      defaultVal();
    }
  }, [defaultValue, options]);

  // support controlled value prop (parent passes option object)
  useEffect(() => {
    if (typeof value !== "undefined") {
      setSelectedValue(value);
    }
  }, [value]);

  const handleChange = (values) => {
    setSelectedValue(values);
    if (onChange) {
      onChange(values);
    }
  };

  const defaultVal = () => {
    const filter = options.filter(
      (option) =>
        String(option[optionValue]).trim().toLowerCase() ===
        String(defaultValue).trim().toLowerCase()
    );
    setSelectedValue(filter[0] || null);
  };

  return (
    <>
      <Select
        options={options}
        value={selectedtValue}
        onChange={handleChange}
        getOptionLabel={
          String(optionLabel).includes("=>")
            ? optionLabel
            : (opt) => opt[optionLabel]
        }
        getOptionValue={(opt) => opt[optionValue]}
        onInputChange={onInputChange}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isRtl={isRtl}
        isMulti={isMulti}
        placeholder={placeholder}
        isOptionDisabled={isOptionDisabled}
        menuPosition={props.menuPosition || "fixed"}
        menuPortalTarget={props.menuPortalTarget !== undefined ? props.menuPortalTarget : document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
      {isAvForm && (
        <AvField
          errorMessage={errorMessage}
          name={name}
          type="hidden"
          value={selectedtValue?.[optionValue]}
          validate={validate}
        />
      )}
    </>
  );
};

export default CustomSelect;
